module.exports = __webpack_public_path__ + "assets/images/animations/hearthy-animation.png?caeb62a6";